import './Services.css';
import '../pages/Services/Services.css';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO/SEO';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-code',
      title: 'Next-Gen Development',
      description:
        'Building tomorrow\'s digital experiences with cutting-edge tech stacks.',
      link: '/services/web-development',
    },
    {
      icon: 'fas fa-mobile-alt',
      title: 'App Innovation Hub',
      description:
        'Crafting mobile-first experiences that redefine user engagement.',
      link: '/services/mobile',
    },
    {
      icon: 'fas fa-cloud',
      title: 'Cloud Transformation',
      description:
        'Powering your digital evolution with scalable cloud solutions.',
      link: '/services/cloud',
    },
    {
      icon: 'fas fa-database',
      title: 'Data Intelligence',
      description:
        'Unlocking insights through smart data analytics and AI integration.',
      link: '/services/data',
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'Cyber Shield',
      description:
        'Next-level security solutions for your digital ecosystem.',
      link: '/services/security',
    },
    {
      icon: 'fas fa-rocket',
      title: 'Digital Acceleration',
      description:
        'Fast-tracking your business growth with innovative tech strategies.',
      link: '/services/consulting',
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Observability & Monitoring',
      description:
        'Real-time visibility and proactive issue detection across your digital infrastructure.',
      link: '/services/observability',
    },
  ];

  return (
    <>
      <SEO
        title="Our Services"
        description="Explore our comprehensive range of technology services including web development, mobile apps, cloud solutions, cybersecurity, observability & monitoring, and digital transformation."
        keywords="IT services, software development, mobile apps, cloud computing, cybersecurity, observability, monitoring, digital transformation"
        canonical="https://sradhatech.com/services"
      />
      <div className="services-page">
        <div className="service-header">
          <h1>What We Do</h1>
          <p>Transforming ideas into powerful digital solutions</p>
        </div>
        <div className="container">

          <div className="services-grid">
            {services.map((service, index) => (
              <div className="service-card" key={index}>
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link to={service.link} className="learn-more">
                  Learn More &rarr;
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
